"use client";
import { useTranslations } from "next-intl";
import { Skeleton } from "@radix-ui/themes";
import { DataInputParams } from "./inputType";
import { Form, Skeleton as AntSkeleton, Radio } from "antd";
import { Debug } from "@/util/debug";
import { checkDisabled, checkNoItem, GetDataInputElement } from "./inputFunction";
import SkeletonInput from "antd/es/skeleton/Input";
import { TransitionType } from "@/components/layout/layoutType";
const getInput = (t: TransitionType, params: DataInputParams) => {
  const disabled = checkDisabled(params);
  const RadioType = params.inputType == "radioButton" ? Radio.Button : Radio;
  if (params.valueList && (params.valueList?.length ?? 0 > 1)) {
    return (
      <Radio.Group onChange={params.onChange} value={params.value} defaultValue={params.value}>
        {params.valueList.map((value) => {
          const label = value.label ? (params.transition && typeof value.label === "string" ? t(value.label) : value.label) : undefined;
          return (
            <RadioType key={params.name + "_" + value.value} value={value.value} disabled={disabled && (value.disabled ?? false)}>
              {label}
            </RadioType>
          );
        })}
      </Radio.Group>
    );
  } else {
    const label =
      typeof params.label == "string"
        ? params.transition
          ? t(params.label)
          : params.label
        : params.label
          ? GetDataInputElement(params.label, false, null, t)
          : undefined;
    const value = params.valueType !== "boolean" ? params.defaultValue : undefined;
    const checked =
      params.valueType !== "boolean"
        ? params.defaultValue !== undefined
          ? params.defaultValue === params.value
          : params.value
        : (params.value ?? params.defaultValue);
    const checkedProp =
      params.inputMode == "view"
        ? { checked: checked }
        : { defaultChecked: checked, id: params.name, name: params.name, onChange: params.onChange };
    // Debug("disabled : " + disabled);
    // Debug("checked : " + checked);
    // Debug("defaultChecked : " + params.defaultValue ? params.defaultValue === params.value : params.value);
    return (
      <RadioType value={value} disabled={disabled} {...checkedProp}>
        {label}
      </RadioType>
    );
  }
};

export default function DataRadio(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
  const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
  const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
  const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
  return (
    <>
      {prev}
      {unitPrev}
      {checkNoItem(params) ? (
        getInput(t, params)
      ) : (
        <Form.Item name={params.name} noStyle valuePropName="checked">
          {getInput(t, params)}
        </Form.Item>
      )}
      {unit}
      {next}
    </>
  );
}
